import { Capacitor } from '@capacitor/core';
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScope } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import UserGrid from './components/UserGrid';

function SiteGroupUserGridView({ match: { params }, ...props }) {
  const { t } = useTranslation();
  const isNativePlatform = Capacitor.isNativePlatform();
  const { customer, siteGroup } = useScope();

  return (
    <AppNav flex notFullHeight page="plant_users" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={t('general.users')} />
        <UserGrid customer={customer} siteGroup={siteGroup} persistScope="siteGroupUserGrid" />
      </Box>
    </AppNav>
  );
}

export default SiteGroupUserGridView;
